import axios from 'axios'
import Global from '../Global'

export default class MailApi {
    constructor(){}

    static listTemplates(session_id){        
        return axios
        .get(Global.GetAPIURL() + '/cpadmin/mail_template_list', {
          headers:{
            "session_id": session_id
          }
        }).catch(function(err) {
         if(typeof err.response != "undefined" && err.response.status == 401){
              Global.logout()
              sessionStorage.setItem("invalid_session_id", true)
          }
      })
    }

    static loadTemplate(session_id, mail_type){        
        let data = {
            "mail_type": mail_type
        }
        return axios
        .post(Global.GetAPIURL() + '/cpadmin/mail_template_load', JSON.stringify(data),{
          headers:{
            "session_id": session_id
          }
        }).catch(function(err) {
         if(typeof err.response != "undefined" && err.response.status == 401){
              Global.logout()
              sessionStorage.setItem("invalid_session_id", true)
          }
      })
    }  
    
    static updateTemplate(session_id, data){    
      if(typeof data.placeholders == "string"){
        data.placeholders = data.placeholders.split(",")    
      }      
        return axios
        .post(Global.GetAPIURL() + '/cpadmin/mail_template_update', JSON.stringify(data),{
          headers:{
            "session_id": session_id
          }
        }).catch(function(err) {
         if(typeof err.response != "undefined" && err.response.status == 401){
              Global.logout()
              sessionStorage.setItem("invalid_session_id", true)
          }
      })
    }
}

